module.exports = __webpack_public_path__ + "static/media/logo-fma.acc44ee4.jpg";